import React, { useEffect, useRef, useState } from "react";
import { DesignField } from "@/components/DesignField";
import { T } from "@/lib/copy";

// THE PLAY / DECISION SCREEN — ported 1:1 from /design rPlay(). Serves trial + real balls.
// props: ball, timerMs, scoreState {score,runsNeeded,ballsLeft,wickets,idx,grid}, trial, freeHit, onLock(optionIndex, ms), lang
export function BallView({ ball, timerMs, scoreState, trial, freeHit, onLock, lang }) {
  const t = T(lang);
  const [pct, setPct] = useState(100);
  const [lockedIdx, setLockedIdx] = useState(null);
  const lockedRef = useRef(false);
  const startRef = useRef(Date.now());
  const intRef = useRef(null);

  useEffect(() => {
    lockedRef.current = false;
    setLockedIdx(null);
    setPct(100);
    startRef.current = Date.now();
    if (intRef.current) clearInterval(intRef.current);
    intRef.current = setInterval(() => {
      const el = Date.now() - startRef.current;
      const p = Math.max(0, 100 - (el / timerMs) * 100);
      setPct(p);
      if (p <= 0 && !lockedRef.current) {
        clearInterval(intRef.current);
        doLock(-1);
      }
    }, 90);
    return () => intRef.current && clearInterval(intRef.current);
    // eslint-disable-next-line
  }, [ball.id, ball.ball_no]);

  function doLock(i) {
    if (lockedRef.current) return;
    lockedRef.current = true;
    if (intRef.current) clearInterval(intRef.current);
    setLockedIdx(i);
    const ms = Math.round(Date.now() - startRef.current);
    // brief beat so the lock glow + ball release register before reveal
    setTimeout(() => onLock(i, ms), i >= 0 ? 620 : 200);
  }

  const locked = lockedIdx != null;
  const released = lockedIdx != null && lockedIdx >= 0;
  const need = scoreState ? scoreState.runsNeeded : 0;
  const dots = Array.from({ length: 6 }).map((_, i) => {
    const cls = !trial && scoreState ? (i < scoreState.idx ? "done" : i === scoreState.idx ? "now" : "") : "";
    return <i key={i} className={cls} />;
  });

  return (
    <div className="dplay" style={{ padding: "16px 16px 18px" }} data-testid="play-screen">
      {trial ? (
        <div className="trial-head" data-testid="trial-ball-banner">
          <div className="trial-label">{t.trial} {trial.n} / {trial.total} · {t.nothingCounts}</div>
          <div className="trial-sub">{t.trialSub}</div>
        </div>
      ) : (
        <>
          <div className="over-dots" data-testid="over-progress-dots">{dots}</div>
          <div className="scorebar" data-testid="decision-scorebar">
            <div className="cell" style={{ flex: 1.1 }}><div className="big">{scoreState.score}-{scoreState.wickets}</div><div className="cap">{t.sbScore}</div></div>
            <div className="cell need" style={{ flex: 1 }}><div className="big" style={{ color: "var(--sm-blaze)" }}>{need}</div><div className="cap" style={{ color: "#C99B6A" }}>{t.sbNeed}</div></div>
            <div className="cell" style={{ flex: 0.8 }}><div className="big">{scoreState.ballsLeft}</div><div className="cap">{t.sbBalls}</div></div>
            <div className="cell" style={{ flex: 0.8 }}><div className="big">{2 - scoreState.wickets}</div><div className="cap">{t.sbWkts}</div></div>
          </div>
          <div className="deck-row">
            {ball.deck && <span className="deck-badge" data-testid="decision-deck-badge">{ball.deck}</span>}
            {ball.header && <span className="deck-header">{ball.header}</span>}
            {freeHit && <span className="freehit-chip" data-testid="decision-free-hit-chip">{t.freeHit}</span>}
          </div>
        </>
      )}

      <DesignField field={ball.field} timerPct={locked ? null : pct} released={released} />

      <div className="play-sit">
        <div className="sit-text">{ball.situation}</div>
        <div className="maidaan-prompt sit-q">{ball.question || t.whatsShot}</div>
      </div>

      <div className="plays" data-testid="decision-options-grid">
        {ball.options.map((o, i) => (
          <button key={i} className={"play" + (lockedIdx === i ? " locked" : locked ? " dim" : "")}
                  disabled={locked} onClick={() => doLock(i)} data-testid={`decision-option-card-${i}`}>
            {lockedIdx === i && <span className="play-lock-badge" data-testid="decision-option-locked-badge">✓ LOCKED</span>}
            <b>{o.label}</b>{o.sub}
          </button>
        ))}
      </div>
    </div>
  );
}
